/** Public marketing routes rendered on the server for SEO and first paint. */
export const PUBLIC_SSR_ROUTES = [
  '/landing',
  '/faq',
  '/contact-us',
  '/privacy-policy',
  '/fira-breakdown',
] as const;

export type PublicSsrRoute = (typeof PUBLIC_SSR_ROUTES)[number];

export function normalizeRoutePath(url: string): string {
  let path = url.split('?')[0].split('#')[0];

  if (path !== '/' && path.endsWith('/')) {
    path = path.slice(0, -1);
  }

  return path || '/';
}

export function isPublicSsrRoute(url: string): boolean {
  const path = normalizeRoutePath(url);

  return PUBLIC_SSR_ROUTES.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
}
